import React, {useContext, useState} from "react";
import "../../styles/users.css";
import {ToastContainer} from "react-toastify";
import {MdAdd} from 'react-icons/md';
import {Button} from "antd";
import PowerBiContext from '../../context/PowerBiContext';
import PageHeading from "../PageHeading";
import AddPowerBi from "./AddPowerBi";
import AddSirReport from "./AddSirReport";
import PowerBiTabs from "./PowerBiTabs";

const Result = () => {
  const user = JSON.parse(localStorage.getItem("admin-user"));
    const powerBiContext = useContext(PowerBiContext);
    const [isSirModalOpen, setIsSirModalOpen] = useState(false);

    const handleModal = () => {
        powerBiContext.updateOpenModal(true);
        console.log("powerBiContext.isOpenModal",powerBiContext.isOpenModal)
    };


    return (
        <div className="users-section">
            <ToastContainer/>

            <PageHeading
                pageTitle='Power BI Module'
                icon={<MdAdd/>}
                pageModalTitle='Add New Power BI Link'
                pageModalOpen={handleModal}
                role={user?.role}
            />

            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
                <Button icon={<MdAdd/>} onClick={() => setIsSirModalOpen(true)}>
                    Add SIR Report
                </Button>
            </div>

            <AddPowerBi isOpen={powerBiContext.isOpenModal} isAddMode={powerBiContext.isAddMode}/>
            <AddSirReport isOpen={isSirModalOpen} onClose={() => setIsSirModalOpen(false)}/>

            <PowerBiTabs/>
        </div>
    );
};

export default Result;